import React, { useState } from 'react';
import { GetServerSideProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import qs from 'query-string';

import absoluteUrl from 'next-absolute-url/index';
import Breadcrumb from 'src/components/Common/breadcrumb';
import SearchPage from 'src/components/Search';
import ListingApis from 'src/api/listings';
import { IListings } from 'src/interface';
import useSearchListings from 'src/hooks/api/listings/useSearchListings';
import SearchPageBanner from 'src/components/Common/pageBanner';
// import AdBanner from '../../components/Adsense';
// import { AdHorizontal } from '../index';
import { generateDescriptionFromListings } from '../../utils/helpers';

interface ISearchProps {
  canonicalUrl: string;
  description: string;
  listingsFromServer: IListings;
}

const Search: NextPage<ISearchProps> = ({ canonicalUrl, description, listingsFromServer }) => {
  const router = useRouter();
  const [viewItems, setViewItems] = useState(parseInt(listingsFromServer.per_page, 10));

  const qry = router.query;
  const shouldFetch =
    viewItems > 10 ? `/search_wanted?${qs.stringify(qry)}&perPage=${viewItems}` : null;
  const { Listings, canLoadMore, isLoading } = useSearchListings(
    listingsFromServer,
    shouldFetch,
    viewItems
  );
  return (
    <>
      <NextSeo
        canonical={canonicalUrl}
        title="Wanted listings search"
        description={description}
        openGraph={{
          url: canonicalUrl,
          title: 'Wanted listings search',
          description,
          images: [
            {
              url: 'https://rentable.pk/assets/logos/green-text-logo.png',
              alt: 'Rentable Pakistan',
            },
          ],
        }}
      />
      <SearchPageBanner />
      <Breadcrumb pathname={router.pathname} />
      <SearchPage
        Listings={Listings}
        canLoadMore={canLoadMore}
        isLoading={isLoading}
        setViewItems={setViewItems}
        isWantedSearch
      />
      {/* <AdHorizontal>
        <AdBanner slotId="9529706829" />
      </AdHorizontal> */}
    </>
  );
};
export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { req, query } = ctx;
  const { origin } = absoluteUrl(req);
  const urlParsed = qs.stringify(query);
  // Get all listings
  const result = await ListingApis.fetchWantedSearchListings(query);
  return {
    props: {
      canonicalUrl: `${origin}/wanted-search${(urlParsed.length && `?${urlParsed}`) || ''}`,
      listingsFromServer: result.data.listings,
      description: generateDescriptionFromListings(result.data.listings, 'Rent ', ``),
    },
  };
};
export default Search;
